import React from "react";
import styled from "styled-components";
// import { CardWrapper } from "../../Components/StyledComponents/StyledComponents";
import AddNftsCard from "./AddNftsCard";

const Root = styled.div``;
const CardWrapper = styled.div`
display:grid;
width:100%;
grid-template-columns: 1fr 1fr 1fr 1fr;
/* grid-gap:${(p) => p.theme.spacing.xxxxxxxl} !important; */
grid-gap:15px !important;
margin-top:${(p) => p.theme.spacing.sm};

@media(min-width:1600px){
  grid-gap:${(p) => p.theme.spacing.xl};
}
@media(max-width:${(p) => p.theme.screen.md}){
  grid-template-columns: 1fr 1fr 1fr;
}
@media(max-width:${(p) => p.theme.screen.sm}){
  grid-template-columns: 1fr 1fr;
}
@media(max-width:${(p) => p.theme.screen.xxs}){
  grid-template-columns: 1fr;
}
`;
const AddNFts = (props) => {
  const { listDetail, getNftData, nftList, viewMoreBtn } = props;
  console.log(listDetail,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;')

  return (
    <Root>
      <CardWrapper>
        {listDetail?.decodedHexData?.length > 0 &&
          listDetail?.decodedHexData.map((nft, index) => {
            return (
              <AddNftsCard
                {...props}
                nftDetail={nft.nftDetail || {}}
                address={nft.address}
                tokenID={nft.tokenID}
                timeStamp={
                  listDetail?.timeStampArray?.length > 0 &&
                  listDetail?.timeStampArray[index]
                }
              />
            );
          })}
        {/* {viewMoreBtn &&
          listDetail?.decodedHexData?.length > 0 &&
          nftList?.length > 0 && (
            <button button onClick={(e) => getNftData(nftList)}>
              View More
            </button>
          )} */}
      </CardWrapper>
    </Root>
  );
};

export default AddNFts;
